import { InstalmentType } from '../../shared/enum/InstalmentType';
import { Term } from '../../shared/types/booking-types';

export enum PaymentPlanReducerTypes {
    SET_MIN_NUMBER_OF_STUDENTS = 1,
    SET_MAX_NUMBER_OF_STUDENTS = 2,
    SET_NUMBER_OF_STUDENTS = 3,
    SET_TERM = 4,
    SET_INSTALMENT_TYPE = 5,
    SET_INSTALMENT_ID = 6,
    CLEAR_PAYMENT_PLAN = 7,
}

export type PaymentPlanReducerAction =
    | { type: PaymentPlanReducerTypes.SET_MIN_NUMBER_OF_STUDENTS; data: number }
    | { type: PaymentPlanReducerTypes.SET_MAX_NUMBER_OF_STUDENTS; data: number }
    | { type: PaymentPlanReducerTypes.SET_NUMBER_OF_STUDENTS; data: number }
    | { type: PaymentPlanReducerTypes.SET_INSTALMENT_TYPE; data: InstalmentType }
    | { type: PaymentPlanReducerTypes.SET_TERM; data: Term }
    | { type: PaymentPlanReducerTypes.SET_INSTALMENT_ID; data: string | null };
